<template>
  <hm-content title="">
    <div>
      <div class="tip-msg flex flex-wrap">
        <div class="tip-img flex flex-column flex-center item-center">
          <img
            src="https://imgcdn.hemiao100.com/ThemePictures/%E7%8C%B4%E5%AD%90.png"
            alt=""
          />
          <div class="tip-name">小助理</div>
        </div>
        <div class="bubbleItem">
          <!--左侧的泡泡-->
          <span class="bubble leftBubble">
            请在{{
              query.timeValue
            }}前请确认该目标，超过该时间，目标按已设定的数据执行!
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
        </div>
      </div>
      <div class="flex item-center okr-title bor-m" style="color: #999999">
        <div class="target-name">目标：{{ basicInfoModel.planName }}</div>
        <div>
          目标时间：{{ basicInfoModel.planStartDate }}至{{
            basicInfoModel.planEndDate
          }}
        </div>
        <div class="target-value">￥{{ basicInfoModel.toPrice }}</div>
        <div class="person-liable">
          总目标负责人：{{ basicInfoModel.realName }}
        </div>
      </div>
      <div>
        <div class="flex item-center okr-title mb10">
          <div class="target-name">
            子目标：{{ targetInfoModel.planTargetName }}
          </div>
          <div class="target-value">￥{{ targetInfoModel.toPrice }}</div>
          <div class="person-liable">
            子目标负责人：{{ targetInfoModel.realName }}
          </div>
        </div>
        <div class="mb40">
          <div class="flex flex-start mb10">
            <div class="okr-title-name">商品目标（{{ query.timeValue }}）</div>
            <div class="pointer edit" @click="edit('修改商品', 'columnList')">
              <span
                class="hmicon icon-bianji blue"
                style="font-size:18px"
              ></span>
            </div>
          </div>
          <div class="">
            <el-table
              ref="table"
              :data="columnList"
              style="width: 800px"
              id="table"
              border
              :row-style="tableRowStyle"
              size="small"
              row-key="id"
              :max-height="400"
              default-expand-all
              :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <el-table-column
                header-align="left"
                align="left"
                prop="goodsName"
                label="商品名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                header-align="right"
                align="right"
                prop="confirmTaskValue"
                label="目标销量"
                width="190"
              >
                <template slot-scope="scope">
                  ￥{{ toPriceNum(scope.row.confirmTaskValue) }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div>
          <div class="flex flex-start mb10">
            <div class="okr-title-name">门店目标（{{ query.timeValue }}）</div>
            <div class="pointer edit" @click="edit('修改门店')">
              <span
                class="hmicon icon-bianji blue"
                style="font-size:18px"
              ></span>
            </div>
            <div class="ml10 danger" style="line-height:18px">
              编辑门店目标之前请先确认商品目标！
            </div>
          </div>

          <div class="" v-if="shopInfoModels.length">
            <el-table
              stripe
              border
              ref="table"
              :data="shopInfoModels"
              style="width: 800px"
              id="table"
              show-summary
              size="small"
              :summary-method="getSummaries"
              :max-height="300"
              :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
            >
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column
                prop="shopName"
                label="门店名称（14家）"
                show-overflow-tooltip
              >
                <template slot="header">
                  门店名称（{{ shopInfoModels.length }}家）
                </template>
              </el-table-column>
              <el-table-column
                prop="confirmSplitValue"
                label="目标销量"
                header-align="right"
                align="right"
                width="190"
              >
                <template slot-scope="scope">
                  ￥{{ toPriceNum(scope.row.confirmSplitValue.toFixed(2)) }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="mt10 flex flex-center">
        <el-button type="primary" size="small" @click="confirm"
          >确 认</el-button
        >
        <el-button type="info" size="small" @click="close">返 回</el-button>
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoods"
      :width="title === '修改商品' ? '1000px' : '900px'"
    >
      <div class="tip-msg flex flex-wrap mb10">
        <div class="tip-img flex flex-column flex-center item-center">
          <img
            src="https://imgcdn.hemiao100.com/ThemePictures/%E7%8C%B4%E5%AD%90.png"
            alt=""
          />
          <div class="tip-name">小助理</div>
        </div>
        <div class="bubbleItem">
          <!--左侧的泡泡-->
          <span class="bubble leftBubble" v-if="title === '修改商品'">
            请输入目标值!
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
          <span v-else class="bubble leftBubble">
            请输入门店比例
            <!-- 请输入门店比例，总比例=100%，若比例有剩余则不可进行保存，剩余可分配比例（<span :class="rest<0?'danger':'success'">{{rest}}%</span> ）! -->
            <span class="bottomLevel"></span>
            <span class="topLevel"></span>
          </span>
        </div>
      </div>
      <div class="flex flex-end mb10">
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出模板数据</el-button
        >

        <el-button type="primary" size="small" class="open-file pointer"
          >导入数据
          <input
            type="file"
            @change="importf"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </el-button>
      </div>
      <div class="bd-1" v-if="title === '修改商品'">
        <el-table
          v-if="dialogVisibleGoods"
          ref="edittable"
          :data="copyColumnList"
          :row-style="tableRowStyle"
          style="width: 100%"
          id="table"
          size="small"
          :max-height="400"
          row-key="id"
          default-expand-all
          :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            v-show="tableHeader.length"
            v-for="(col, index) in tableHeader"
            :key="index"
            min-width="280px"
            :prop="col.columnName"
            :label="col.labelName"
            :column-key="index.toString()"
          >
            <template slot-scope="scope">
              <template v-if="scope.$index === 0">
                <span v-if="col.columnName === 'goodsName'">
                  {{ scope.row[col.columnName] }}
                </span>
                <div v-else style="display: inline-block">
                  <div>
                    <!-- {{ scope.row.planValue }} -->
                    ￥<el-input
                      type="number"
                      size="small"
                      class="mr10 ipt"
                      style="width: 150px"
                      v-model.trim="scope.row.confirmTaskValue"
                      @focus="confirmTaskValueFocus(scope.row.confirmTaskValue)"
                      @blur="
                        confirmTaskValueFocusBlur(
                          scope.row,
                          scope.row.confirmTaskValue
                        )
                      "
                      placeholder="请输入"
                    ></el-input>
                  </div>
                  <!-- <div
                    class="danger"
                    v-if="scope.row.planValue < scope.row.confirmTaskValue"
                  >
                    {{ scope.row.confirmTaskValue }}
                  </div> -->
                </div>

                <span
                  v-if="
                    col.columnName === 'goodsName' &&
                      scope.row.goodsName !== '其他'
                  "
                  class="add-wrapper"
                  style="display: inline-block"
                  @click="add(scope.row, scope.$index)"
                >
                  <span class="hmicon icon-hao pointer"></span>
                </span>
                <!-- <span
                  v-if="
                    col.columnName === 'goodsName' &&
                    scope.row.goodsName !== '' &&
                    scope.row.goodsName !== '其他'
                  "
                  class="minus-wrapper"
                  style="display: inline-block"
                  @click="del(scope.row, scope.$index)"
                >
                  <span class="hmicon icon-jianhao pointer"></span>
                </span> -->
              </template>
              <template v-else>
                <div
                  style="display: inline-block"
                  v-if="col.columnName !== 'confirmTaskValue'"
                >
                  {{ scope.row[col.columnName] }}

                  <span
                    v-if="
                      col.columnName === 'goodsName' &&
                        scope.row.goodsName !== '其他'
                    "
                    class="add-wrapper"
                    style="display: inline-block"
                    @click="add(scope.row, scope.$index)"
                  >
                    <span class="hmicon icon-hao pointer"></span>
                  </span>
                  <span
                    v-if="
                      col.columnName === 'goodsName' &&
                        scope.row.goodsName !== '' &&
                        scope.row.goodsName !== '其他'
                    "
                    class="minus-wrapper"
                    style="display: inline-block"
                    @click="del(scope.row, scope.$index)"
                  >
                    <!-- &&
                      scope.row.aaa === 'aaa' -->
                    <span class="hmicon icon-jianhao pointer"></span>
                  </span>
                </div>
                <span>{{
                  col.columnName === "confirmTaskValue" &&
                  scope.row.goodsName !== "其他"
                    ? "￥"
                    : ""
                }}</span>
                <el-input
                  v-if="
                    col.columnName === 'confirmTaskValue' &&
                      scope.row.goodsName !== '其他'
                  "
                  type="number"
                  size="small"
                  class="mr10 ipt"
                  style="width: 150px"
                  v-model.trim="scope.row[col.columnName]"
                  @focus="otherFocus(scope.row[col.columnName])"
                  @blur="otherBlur(scope.row, col.columnName)"
                  placeholder="请输入"
                ></el-input>
                <span
                  v-if="
                    scope.row.goodsName === '其他' &&
                      col.columnName === 'confirmTaskValue'
                  "
                >
                  ￥ {{ toPriceNum(scope.row[col.columnName]) }}
                </span>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else>
        <el-table
          ref="table"
          :data="copyColumnList"
          style="width: 100%"
          id="table"
          size="small"
          :row-style="tableRowStyle"
          border
          :max-height="400"
          row-key="id"
          default-expand-all
          :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            v-show="tableHeader.length"
            v-for="(col, index) in tableHeader"
            :key="index"
            :prop="col.columnName1"
            :label="col.labelName"
            show-overflow-tooltip
            :align="index > 0 ? 'right' : 'left'"
            :min-width="index === 0 ? '160px' : '150px'"
            :column-key="index.toString()"
          >
            <!-- <template slot="header" slot-scope="scope">
              <div class="flex flex-column flex-between">
                 <el-tooltip :content="col.labelName" placement="top-start">
                <div class="flex flex-center text-overflow">{{ col.labelName }}</div>
                 </el-tooltip>
                <div
                  class="bm flex flex-center"
                  v-if="col.columnName !== 'goodsName'"
                >

                <template   v-if="col.labelName !== '总计'">
                      <el-input
                    @input="change"
                    type="number"
                    size="small"
                    class="ipt"
                    @blur="plitValueBlur(col,col.confirmSplitValue)"
                    v-model.trim="col.confirmSplitValue"
                    placeholder="请输入"
                  > 
                  </el-input
                  >% 
                </template>
              
                  <span v-if="col.labelName === '总计'">{{ col.labelName2 }}%</span>
                  

                </div>
              </div>
            </template> -->
            <template slot-scope="scope">
              <span v-if="index === 0">
                {{ scope.row[col.columnName1] }}
              </span>
              <div v-else>
                ￥
                <el-input
                  type="number"
                  size="small"
                  class="mr10 ipt"
                  style="width: 150px"
                  clearable
                  v-model.trim="scope.row[col.columnName1]"
                  @blur="otherBlur(scope.row, col.columnName1)"
                  placeholder="请输入"
                ></el-input>
              </div>

              <!-- {{ index !=0  ? toPriceNum(scope.row[col.columnName]) :  scope.row[col.columnName]}} -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        width="1200px"
        title="添加商品"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        append-to-body
      >
        <hm-shop-goods-okr
          v-if="dialogVisible"
          type="microShop"
          :params="row"
          :visible="dialogVisible"
          @saveGoods="saveGoods"
          @close="dialogVisible = false"
        ></hm-shop-goods-okr>
      </el-dialog>
      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="submitRuleForm('ruleForm')"
          size="small"
          type="primary"
          >确认</el-button
        >

        <el-button size="small" type="info" @click="dialogVisibleGoods = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmShopGoodsOkr from "@/components/HmShopGoodsOkr";
import {
  arrayUnique2,
  toPrice,
  treeConvertToArr,
  ToFixed
} from "@/utils/utils";

import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: { HmShopGoodsOkr },
  data() {
    return {
      itemkey: "",
      tableHeader: [],
      columnList: [],
      copyColumnList: [],
      title: "",
      dialogVisibleGoods: false,
      dialogVisible: false,
      goodsList: [],
      row: {},
      addRow: {},
      query: JSON.parse(this.$route.query.row),
      basicInfoModel: {},
      shopInfoModels: [],
      targetInfoModel: {},
      oldValue: 0,
      tableHeaderRadio: {},
      rest: 0,
      isOutputing: false
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryDetails();
  },
  methods: {
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;

        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        console.log("result: ", result);
        let goodsList = [];
        if (that.title === "修改商品") {
          console.log("this.title: ", that.title);
          result.forEach(v => {
            goodsList.push({
              id: v[0],
              goodsName: v[1],
              confirmTaskValue: ToFixed(v[2] || 0, 2)
            });
          });
          console.log("goodsList: ", goodsList);
          goodsList.forEach(v => {
            that.mapAry(that.copyColumnList, v);
          });
        } else {
          result.forEach((v, i) => {
            goodsList.push({});

            v.forEach((j, k) => {
              if (k === 0) {
                Object.assign(goodsList[i], { id: j });
              } else if (k !== 1) {
                let key = "confirmSplitValue" + (k - 2);
                Object.assign(goodsList[i], { [key]: ToFixed(j || 0, 2) });
              }
            });
          });

          goodsList.forEach(v => {
            that.mapTreeShop(that.copyColumnList, v);
          });
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    //导出excel
    output() {
      this.isOutputing = true;
      if (this.title === "修改商品") {
        require.ensure([], () => {
          const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
          this.isOutputing = true;
          const list = treeConvertToArr(this.copyColumnList);
          console.log("list: ", list);
          const tHeader = ["ID(请勿修改)", "目标商品", "目标值"];
          const filterVal = ["id", "goodsName", "confirmTaskValue"];
          const data = this.formatJson(filterVal, list);
          exportJsonToExcel(
            tHeader,
            data,
            "导出模板" + new Date().toLocaleString()
          );
          this.isOutputing = false;
        });
      } else {
        require.ensure([], () => {
          const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
          this.isOutputing = true;
          const list = treeConvertToArr(this.copyColumnList);
          const tHeader = [];
          const filterVal = [];
          console.log("this.tableHeader: ", this.tableHeader);
          this.tableHeader.map((v, i) => {
            if (i) {
              tHeader.push(v.labelName);
              filterVal.push(v.columnName1);
            } else {
              tHeader.push("目标商品");
              filterVal.push(v.columnName1);
            }
          });
          tHeader.unshift("ID(请勿修改)");
          filterVal.unshift("id");

          const data = this.formatJson(filterVal, list);
          exportJsonToExcel(
            tHeader,
            data,
            "导出模板" + new Date().toLocaleString()
          );
          this.isOutputing = false;
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    //导入的递归
    mapAry(arr, item) {
      arr.forEach(v => {
        if (v.id == item.id) {
          v.confirmTaskValue = item.confirmTaskValue;
        }
        if (v.children && v.children.length) {
          this.mapAry(v.children, item);
        }
      });
    },
    //导入的递归
    mapTreeShop(arr, item) {
      arr.forEach(v => {
        if (v.id == item.id) {
          Object.assign(v, item);
        }
        if (v.children && v.children.length) {
          this.mapTreeShop(v.children, item);
        }
      });
    },
    tableRowStyle({ row }) {
      return `background:rgba(221, 221, 221, ${row.backGround})`;
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = "￥" + this.toPriceNum(sums[index].toFixed(2));
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    confirmTaskValueFocus(val) {
      this.oldValue = val;
    },
    confirmTaskValueFocusBlur(row, val) {
      row.confirmTaskValue = ToFixed(val, 2);
      // if (val >= row.planValue) {
      //   let otherValue =
      //     this.copyColumnList[0].children[
      //       this.copyColumnList[0].children.length - 1
      //     ].confirmTaskValue +
      //     (val - this.oldValue);
      //   this.$set(
      //     this.copyColumnList[0].children[
      //       this.copyColumnList[0].children.length - 1
      //     ],
      //     "confirmTaskValue",
      //     otherValue
      //   );
      // } else {
      //   this.mapTreeClearable(
      //     this.copyColumnList[0].children,
      //     "confirmTaskValue"
      //   );
      //   this.$set(
      //     this.copyColumnList[0].children[
      //       this.copyColumnList[0].children.length - 1
      //     ],
      //     "confirmTaskValue",
      //     val
      //   );
      // }
    },
    async confirm() {
      let shopTaskDetailInfo = JSON.parse(JSON.stringify(this.shopInfoModels));
      shopTaskDetailInfo.forEach(v => {
        v.confirmSplitValue = v.targetConfirmRatio;
      });
      let params = {
        planId: this.query.planId,
        columnList: this.columnList,
        shopTaskDetailInfo,
        timeType: this.query.timeType,
        timeValue: this.query.timeValue,
        targetId: this.query.targetId
      };
      const { code } = await this.$store.dispatch(
        "saveOkrTaskConfirmInfo",
        params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.close();
      }
    },
    change() {
      // this.$nextTick(() => {
      //   console.log(row);
      //   this.$set(this.tableHeader[i], "confirmSplitValue", val);
      // });
      // this.tableHeader.map(v => {
      //   v.confirmSplitValue = v.confirmSplitValue;
      // });
      this.$forceUpdate();
    },
    mapTree(arr, prop, val) {
      arr.forEach(items => {
        //遍历树
        items[prop] = (items.splitRatio * val * 0.01).toFixed(2);
        if (items.children && items.children.length) {
          this.mapTree(items.children, prop, val);
        }
      });
    },
    mapTreeFixed2(arr, prop) {
      arr.forEach(items => {
        //遍历树
        // items[prop] = ToFixed(items[prop], 2);
        this.$set(items, prop, ToFixed(items[prop], 2));
        if (items.children && items.children.length) {
          this.mapTreeFixed2(items.children, prop);
        }
      });
    },
    //清空出節點的值
    mapTreeClearable(arr, prop) {
      arr.forEach(items => {
        //遍历树
        this.$set(items, prop, 0);
        if (items.children && items.children.length) {
          this.mapTree(items.children, prop);
        }
      });
    },
    plitValueBlur(row, val) {
      // this.$set(row, "confirmSplitValue", val);
      this.mapTree(this.copyColumnList[0].children, row.columnName, val);
      this.queryTotalRatio();
    },
    queryTotalRatio() {
      let total = 0;
      this.tableHeader.map(v => {
        if (v.columnName1.indexOf("confirmSplitValue") === 0) {
          total += v.confirmSplitValue * 1;
        }
      });
      this.rest = (100 - total).toFixed(2);
    },
    async queryShopTargetSplitInfo() {
      this.tableHeader = [];
      const { code, result } = await this.$store.dispatch(
        "queryTargetSplitShopConfirmInfo",
        {
          targetId: this.query.targetId,
          planId: this.query.planId,
          timeValue: this.query.timeValue
        }
      );
      if (code === "0") {
        const { headersList, columnList } = result;

        headersList.forEach((v, i) => {
          if (
            v.columnName1.indexOf("confirmSplitValue") === 0 ||
            v.columnName1 === "confirmSplitValue"
          ) {
            v[v.columnName1] = JSON.parse(JSON.stringify(v.confirmSplitValue));
          }
          if (i) {
            this.mapTreeFixed2(columnList, v.columnName);
          }
        });
        this.tableHeader = [...headersList];

        this.mapBackGroundArr(columnList, 1);
        this.copyColumnList = columnList;
        this.$forceUpdate();
      }
    },
    mapBackGroundArr(arr, num) {
      arr.forEach(item => {
        if (item.children && item.children.length > 0) {
          item.backGround = num - 0.15;
          this.mapBackGroundArr(item.children, num - 0.15);
        }
      });
    },
    async saveOkrTaskDetailConfirmInfo() {
      let params = {
        planId: this.query.planId,
        timeValue: this.query.timeValue,
        targetId: this.query.targetId,
        columnList: this.copyColumnList
      };
      const { code } = await this.$store.dispatch(
        "saveOkrTaskDetailConfirmInfo",
        params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.dialogVisibleGoods = false;
        this.queryDetails();
      }
    },
    // splitTree(arr, key) {
    //   let tree = [];
    //   arr.forEach(item => {
    //     tree.push({
    //       confirmSplitValue: item[key]
    //     });
    //     if (
    //       item.hasOwnProperty("children") &&
    //       item.children &&
    //       item.children.length > 0
    //     ) {
    //       //判断chlidren是否有数据
    //       tree.push({
    //       children: item[key]
    //     });
    //       this.splitTree(item.children, item); //递归调用
    //     }
    //   });
    // },
    async saveOkrTaskShopConfirmInfo() {
      let headersList = JSON.parse(JSON.stringify(this.tableHeader));
      let columnList = JSON.parse(JSON.stringify(this.copyColumnList));
      headersList.splice(0, 1);
      // console.log("tableHeader: ", tableHeader);
      // copyColumnList.splice(0, 1);
      // console.log("copyColumnList: ", copyColumnList);
      // list.forEach(v => {
      //   v.confirmSplitValue = v[v.columnName1];
      // });
      let params = {
        planId: this.query.planId,
        timeValue: this.query.timeValue,
        targetId: this.query.targetId,
        headersList,
        columnList
      };
      const { code } = await this.$store.dispatch(
        "saveOkrTaskShopConfirmInfo",
        params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.dialogVisibleGoods = false;
        this.queryDetails();
      }
    },
    submitRuleForm() {
      if (this.title === "修改商品") {
        this.saveOkrTaskDetailConfirmInfo();
      } else {
        // if (this.rest == 0) {
        this.saveOkrTaskShopConfirmInfo();
        // } else {
        //   this.$message({
        //     message: "门店总比例需达到100%，若比例有剩余或者超出则不可进行保存",
        //     type: "warning"
        //   });
        // }
      }
    },
    queryTargetTotalled(arr, key) {
      let total = 0;
      arr.forEach(v => {
        total += v[key] * 1;
      });
      this.$set(this.copyColumnList[0], key, total);
    },
    //得到当前层级所有节点
    queryTree(arr, id, items, confirmTaskValue) {
      arr.forEach(item => {
        //利用foreach循环遍历
        if (item.id == id) {
          //判断递归结束条件
          arr.forEach((v, i) => {
            this.$set(arr, i, v);
          });
          this.currentAllNode = arr;
          this.parentItem = items;

          let childrenAllTotal = 0;
          let childrenTotal = 0;

          //算出修改前后差值
          let remainder = this.oldValue - item[confirmTaskValue];
          // console.log("remainder", remainder);
          if (item.hasOwnProperty("children")) {
            item.children.forEach(v => {
              childrenAllTotal +=
                v[confirmTaskValue] === "" || !v[confirmTaskValue]
                  ? 0
                  : v[confirmTaskValue] * 1;
              if (v.goodsName !== "其他") {
                childrenTotal +=
                  v[confirmTaskValue] === "" || !v[confirmTaskValue]
                    ? 0
                    : v[confirmTaskValue] * 1;
              }
            });

            // console.log("childrenAllTotal", childrenAllTotal);
          }
          if (item[confirmTaskValue] < childrenAllTotal) {
            this.$confirm(
              `当前目标值不能低于(${childrenAllTotal}),如确定修改会导致所有子级目标值清空，是否确定修改!!`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }
            )
              .then(() => {
                this.delAllPlanValue(item.children, confirmTaskValue);
                // this.queryTargetTotalled(arr, confirmTaskValue);
                this.$set(
                  item.children[item.children.length - 1],
                  confirmTaskValue,
                  item[confirmTaskValue]
                );
                arr[arr.length - 1][confirmTaskValue] =
                  arr[arr.length - 1][confirmTaskValue] -
                  (item[confirmTaskValue] - this.oldValue * 1);
              })
              .catch(() => {
                this.$set(item, confirmTaskValue, this.oldValue);
              });
            // this.$message({
            //   message: `当前目标值不能低于(${childrenAllTotal}),如需修改请先修改子级的目标值!!`,
            //   type: "warning"
            // });
            // this.$set(item, confirmTaskValue, childrenAllTotal);
          } else {
            // console.log("item[confirmTaskValue]", item[confirmTaskValue]);
            // console.log(
            //   "arr[arr.length - 1][confirmTaskValue]",
            //   arr[arr.length - 1][confirmTaskValue]
            // );
            // console.log("remainder", remainder);
            // console.log(arr[arr.length - 1][confirmTaskValue] + remainder);
            // console.log(" this.oldValue", this.oldValue);
            // console.log(
            //   "remainder",
            //   item[confirmTaskValue] <=
            //     arr[arr.length - 1][confirmTaskValue] + this.oldValue * 1
            // );
            if (
              new Number(arr[arr.length - 1][confirmTaskValue]) + remainder >=
              0
            ) {
              // console.log("其他", arr[arr.length - 1][confirmTaskValue]);
              // console.log("改动前", item[confirmTaskValue]);
              // console.log("改动后", this.oldValue);
              let num =
                arr[arr.length - 1][confirmTaskValue] -
                (item[confirmTaskValue] - this.oldValue * 1);
              arr[arr.length - 1][confirmTaskValue] = parseFloat(num).toFixed(
                2
              );
              if (item.children.length) {
                let num =
                  item.children[item.children.length - 1][confirmTaskValue] *
                    1 +
                  (item[confirmTaskValue] - this.oldValue * 1);

                item.children[item.children.length - 1][
                  confirmTaskValue
                ] = parseFloat(num).toFixed(2);
              }
            } else {
              this.$message({
                message: `当前可分配目标值不足（可分配目标值${
                  arr[arr.length - 1][confirmTaskValue]
                }），请先修改父级目标值!!`,
                type: "warning"
              });
              this.$set(item, confirmTaskValue, this.oldValue);
            }

            //判断当前层的其他值比修改的差值大则用其他值减去差值
            // if (arr[arr.length - 1][confirmTaskValue] >= remainder) {
            //   this.$set(
            //     items.children[items.children.length - 1],
            //     confirmTaskValue,
            //     items.children[items.children.length - 1][confirmTaskValue] -
            //       remainder
            //   );
            // }
            // console.log("this.copyColumnList[0]", this.copyColumnList[0]);
            // if (remainder < 0) {
            //   let otherRemainder = Math.abs(
            //     items.children[items.children.length - 1][confirmTaskValue] +
            //       remainder
            //   );
            //   console.log("items", items);
            //   this.queryValue(this.copyColumnList, items.id, otherRemainder);
            //   this.$set(
            //     items.children[items.children.length - 1],
            //     confirmTaskValue,
            //     0
            //   );
            // } else {
            //   this.$set(
            //     items.children[items.children.length - 1],
            //     confirmTaskValue,
            //     items.children[items.children.length - 1][confirmTaskValue] +
            //       remainder
            //   );
            // }
            // console.log(" item[confirmTaskValue]", item[confirmTaskValue]);
            // if (item.children.length) {
            //   this.$set(
            //     item.children[item.children.length - 1],
            //     confirmTaskValue,
            //     item[confirmTaskValue] - childrenTotal
            //   );
            // }
            // this.queryTargetTotalled(arr, confirmTaskValue);
          }
          return arr;
        }
        if (item.children && item.children.length > 0) {
          //判断chlidren是否有数据

          this.queryTree(item.children, id, item, confirmTaskValue); //递归调用
        }
      });
    },
    queryValue(arr, id, otherRemainder, items) {
      arr.forEach(item => {
        if (item.id == id) {
          // console.log("arr", arr);
          // console.log("items", items);
          // console.log("otherRemainder", otherRemainder);
          if (items) {
            let remainder =
              otherRemainder -
              items.children[items.children.length - 1].confirmTaskValue;
            if (remainder > 0) {
              this.$set(
                items.children[items.children.length - 1],
                "confirmTaskValue",
                0
              );
              this.queryValue(this.copyColumnList, items.id, remainder);
            } else {
              this.$set(
                items.children[items.children.length - 1],
                "confirmTaskValue",
                items.children[items.children.length - 1] + remainder
              );

              return;
            }
          } else {
            this.$set(
              this.copyColumnList[0],
              "confirmTaskValue",
              this.copyColumnList[0].confirmTaskValue + otherRemainder
            );
            return;
          }
        }
        if (
          item.hasOwnProperty("children") &&
          item.children &&
          item.children.length > 0
        ) {
          //判断chlidren是否有数据
          let arr = arr;
          this.queryValue(item.children, id, otherRemainder, item); //递归调用
        }
      });
    },
    //实时求出其他合计
    queryDiff(row, key) {
      this.queryTree(
        this.copyColumnList[0].children,
        row.id,
        this.copyColumnList[0],
        key
      );
    },
    otherFocus(val) {
      this.oldValue = val;
    },
    otherBlur(row, key) {
      // row[key] = new Number(row[key]);
      row[key] = ToFixed(row[key], 2);
      // this.queryValue(row);
      // this.queryDiff(row, key);
    },
    filterGt0OrFixed2(prop) {
      // prop = prop.replace(/^(0+)/, ""); //过滤0开头
      prop = prop.replace(/[^\d.]/g, ""); //仅保留数字和"."
      prop = prop.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      prop = prop
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      prop = prop.replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (prop.indexOf(".") < 0 && prop != "") {
        //首位是0的话去掉
        prop = parseFloat(prop);
      }
      return prop;
    },
    edit(title, list) {
      console.log("list: ", list);
      console.log("title: ", title);
      this.title = title;
      this.dialogVisibleGoods = true;
      if (title === "修改门店") {
        this.tableHeader = [];
        this.copyColumnList = [];
        this.queryShopTargetSplitInfo();
      } else {
        this.copyColumnList = [];
        this.copyColumnList = JSON.parse(JSON.stringify(this[list]));
        console.log("this.copyColumnList: ", this.copyColumnList);
        this.tableHeader = [
          {
            labelName: "目标商品",
            columnName: "goodsName"
          },
          {
            labelName: this.query.timeValue,
            columnName: "confirmTaskValue"
          }
        ];
      }
    },
    toPriceNum(num) {
      if (isNaN(num)) {
        num = 0;
      }
      return (
        num &&
        num.toString().replace(/\d+/, function(s) {
          return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        })
      );
    },
    close() {
      this.$router.back(-1);
      // this.$router.push({
      //   name: "OkrWorkSplit"
      // });
    },
    async queryDetails() {
      const { code, result } = await this.$store.dispatch(
        "queryOkrTargetSplitConfirmInfo",
        this.query
      );
      if (code === "0") {
        const {
          basicInfoModel,
          columnList,
          shopInfoModels,
          targetInfoModel
        } = result;
        basicInfoModel.toPrice = toPrice(basicInfoModel.planValue.toFixed(2));
        targetInfoModel.toPrice = toPrice(
          targetInfoModel.splitValue.toFixed(2)
        );
        // columnList.forEach(v => {
        //   v.confirmTaskValue = v.confirmTaskValue.toFixed(2);
        // });
        this.forTree(columnList);
        this.mapBackGroundArr(columnList, 1);
        this.columnList = columnList;
        this.shopInfoModels = shopInfoModels;
        this.basicInfoModel = basicInfoModel;
        this.targetInfoModel = targetInfoModel;
      }
    },
    forTree(arr) {
      arr.forEach(item => {
        item.confirmTaskValue = item.confirmTaskValue.toFixed(2);
        if (item.children && item.children.length > 0) {
          this.forTree(item.children);
        }
      });
    },
    saveGoods(data) {
      data.forEach(v => {
        v.goodsName = v.name;
        this.$set(v, "confirmTaskValue", 0);
        this.$set(v, "planValue", 0);
      });
      if (this.row.goodsName === "") {
        Object.assign(this.tableData[0], data[0]);
        this.$forceUpdate();
        this.dialogVisible = false;
        this.itemkey = Math.random();
      } else {
        console.log("this.row: ", this.row);
        this.row.children.push(...data);
        this.row.children = arrayUnique2(this.row.children, "id");
        this.$forceUpdate();
        this.dialogVisible = false;
        this.itemkey = Math.random();
        this.$set(
          this.$refs.table.store.states.lazyTreeNodeMap,
          this.row.id,
          this.row.children
        );

        // this.otherBlur(row, "confirmTaskValue");
      }
      // data.goodsName = data.name;
      // this.$set(data, "confirmTaskValue", 0);
      // this.$set(data, "planValue", 0);
      // if (this.row.goodsName === "") {
      //   Object.assign(this.tableData[0], data);
      //   this.$forceUpdate();
      //   this.dialogVisible = false;
      //   this.itemkey = Math.random();
      // } else {
      //   if (this.row.hasOwnProperty("children") && this.row.children.length) {
      //     let row = Object.assign({}, this.addRow, data);
      //     this.row.children.splice(this.row.children.length - 1, 0, row);
      //     this.row.children = arrayUnique2(this.row.children, "id");
      //     this.$forceUpdate();
      //     this.dialogVisible = false;
      //     this.itemkey = Math.random();
      //     this.$set(
      //       this.$refs.table.store.states.lazyTreeNodeMap,
      //       this.row.id,
      //       this.row.children
      //     );

      //     // this.otherBlur(row, "confirmTaskValue");
      //   } else {
      //     this.row.children = [];
      //     this.row.children.push(Object.assign({}, this.addRow, data));
      //     // this.other.id = Math.random();
      //     // let row = JSON.parse(JSON.stringify(this.addRow));
      //     // row.goodsName = "其他";
      //     // row.id = Math.random();

      //     // row.confirmTaskValue = this.row.confirmTaskValue;
      //     // // row.planValue = this.row.planValue;
      //     // this.row.children.push(Object.assign({}, row));
      //     this.$forceUpdate();
      //     this.dialogVisible = false;
      //     this.itemkey = Math.random();

      //     this.$set(
      //       this.$refs.table.store.states.lazyTreeNodeMap,
      //       this.row.id,
      //       this.row.children
      //     );

      //     // this.otherBlur(this.row.children[0], "confirmTaskValue");
      //   }
      //   this.mapBackGroundArr(this.copyColumnList, 1);
      //   // this.$refs.edittable.rowStyle();
      // }
    },
    //删除所有子节点的目标值
    delAllPlanValue(arr, confirmTaskValue) {
      arr.forEach(item => {
        this.$set(item, confirmTaskValue, 0);
        if (item.children && item.children.length > 0) {
          this.delAllPlanValue(item.children, confirmTaskValue);
        }
      });
    },
    add(row) {
      if (row.confirmTaskValue == 0 || !row.confirmTaskValue) {
        this.$message({
          message: "请先设置当前目标值",
          type: "warning"
        });
      } else {
        this.$forceUpdate();
        this.row = row;
        this.row.targetId = this.query.targetId;

        this.dialogVisible = true;
      }
    },
    del(row) {
      this.delFindById(this.copyColumnList, row.id);
    },
    //遍历节点，删除节点
    delFindById(arr, id) {
      this.returnedItem = {};
      arr.forEach((item, index) => {
        //利用foreach循环遍历
        if (item.id == id) {
          //判断递归结束条件
          if (item.children && item.children.length >= 1) {
            this.$confirm("该节点下存在子节点,是否确定删除?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              this.$set(
                arr[arr.length - 1],
                "confirmTaskValue",
                arr[arr.length - 1].confirmTaskValue * 1 +
                  item.confirmTaskValue * 1
              );
              // if (arr.length === 2) {
              //   arr.splice(0, 2);
              // } else {
              //   arr.splice(index, 1);
              // }
              arr.splice(index, 1);
              this.itemkey = Math.random();
            });
          } else {
            this.$set(
              arr[arr.length - 1],
              "confirmTaskValue",
              arr[arr.length - 1].confirmTaskValue * 1 +
                item.confirmTaskValue * 1
            );
            arr.splice(index, 1);
            // if (arr.length === 2) {
            //   arr.splice(0, 2);
            // } else {
            //   arr.splice(index, 1);
            // }
            this.itemkey = Math.random();
          }
          return item;
        } else if (item.children && item.children.length > 0) {
          //判断chlidren是否有数据
          this.delFindById(item.children, id); //递归调用
        }
      });
    }
  }
};
</script>
<style lang="scss">
// .gbc {
//   background: red !important;
// }
</style>
<style lang="scss" scoped>
.mb40 {
  margin-bottom: 40px;
}
.bm {
  border-top: 1px solid #ebeef5;
}
.bd-1 {
  border: 1px solid #dddddd;
}
.bor-m {
  border-bottom: 1px solid #f4f4f4;
}
.okr-title-name {
  font-weight: 600;
  padding: 0 10px;
  font-size: 15px;
}
.okr-title {
  font-weight: 600;
  padding: 0 10px;
  height: 70px;
  font-size: 17px;
  div {
    margin-right: 80px;
  }
}
</style>
